(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mellooa-comfort-features-scroll-v2"] && !Shopify.designMode) return;
  try {
    
(() => {
  const selector = '[data-mellooa-comfort-scroll]';

  const getStableInset = () => {
    const styles = getComputedStyle(document.documentElement);
    const value = (name) => Number.parseFloat(styles.getPropertyValue(name)) || 0;

    return value('--announcement-bar-is-sticky') * value('--announcement-bar-height')
      + value('--header-is-sticky') * value('--header-height');
  };

  const init = (scroller) => {
    if (scroller.dataset.mellooaComfortScroll === 'ready') {
      return;
    }

    const section = scroller.closest('.shopify-section--mellooa-comfort-features-scroll');

    if (!section) {
      return;
    }

    scroller.dataset.mellooaComfortScroll = 'ready';
    section.classList.add('is-scroll-driven');

    const controller = new AbortController();
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const desktopMotion = window.matchMedia('(min-width: 1000px)');
    const spacer = scroller.querySelector('.mellooa-comfort-story__spacer');
    const items = Array.from(scroller.querySelectorAll('.images-with-text-scroll__item'));
    const useCasesSection = document.querySelector('.shopify-section--mellooa-use-cases');
    let frame = null;
    let resizeTimer = null;
    let inset = 0;
    let maxScroll = 0;
    let stepDistance = 1;

    const clearMotion = () => {
      items.forEach((item) => {
        item.style.removeProperty('pointer-events');

        [
          item.querySelector('.images-with-text-scroll__image'),
          item.querySelector('.images-with-text-scroll__text')
        ].filter(Boolean).forEach((element) => {
          element.style.removeProperty('--mellooa-comfort-motion-opacity');
          element.style.removeProperty('--mellooa-comfort-motion-y');
          element.style.removeProperty('--mellooa-comfort-motion-scale');
        });
      });
    };

    const updateMotion = (progress) => {
      if (!desktopMotion.matches || reducedMotion.matches) {
        return;
      }

      const slideProgress = Math.min(items.length - 1, Math.max(0, progress / Math.max(stepDistance, 1)));
      const baseIndex = Math.min(items.length - 1, Math.floor(slideProgress));
      const localProgress = slideProgress - baseIndex;
      const smoothstep = (start, end, value) => {
        const amount = Math.min(1, Math.max(0, (value - start) / (end - start)));
        return amount * amount * (3 - 2 * amount);
      };

      items.forEach((item, index) => {
        let imageOpacity = 0;
        let textOpacity = 0;
        let imageMotionProgress = 1;
        let textMotionProgress = 1;
        let direction = 1;

        if (index === baseIndex) {
          imageMotionProgress = smoothstep(.34, .56, localProgress);
          textMotionProgress = smoothstep(.26, .44, localProgress);
          imageOpacity = 1 - imageMotionProgress;
          textOpacity = 1 - textMotionProgress;
          direction = -1;
        } else if (index === baseIndex + 1) {
          const imageEntrance = smoothstep(.44, .66, localProgress);
          const textEntrance = smoothstep(.56, .74, localProgress);
          imageOpacity = imageEntrance;
          textOpacity = textEntrance;
          imageMotionProgress = 1 - imageEntrance;
          textMotionProgress = 1 - textEntrance;
          direction = 1;
        }

        const image = item.querySelector('.images-with-text-scroll__image');
        const text = item.querySelector('.images-with-text-scroll__text');

        item.style.pointerEvents = Math.max(imageOpacity, textOpacity) > .5 ? 'auto' : 'none';

        if (image) {
          image.style.setProperty('--mellooa-comfort-motion-opacity', imageOpacity.toFixed(3));
          image.style.setProperty('--mellooa-comfort-motion-y', `${(direction * imageMotionProgress * 64).toFixed(2)}px`);
          image.style.setProperty('--mellooa-comfort-motion-scale', (1 - imageMotionProgress * .025).toFixed(3));
        }

        if (text) {
          text.style.setProperty('--mellooa-comfort-motion-opacity', textOpacity.toFixed(3));
          text.style.setProperty('--mellooa-comfort-motion-y', `${(direction * textMotionProgress * 84).toFixed(2)}px`);
          text.style.setProperty('--mellooa-comfort-motion-scale', '1');
        }
      });
    };

    const update = () => {
      frame = null;

      if (reducedMotion.matches || maxScroll <= 0) {
        return;
      }

      const sectionRect = section.getBoundingClientRect();
      const progress = Math.min(maxScroll, Math.max(0, inset - sectionRect.top));

      if (Math.abs(scroller.scrollTop - progress) > 0.5) {
        scroller.scrollTop = progress;
      }

      updateMotion(progress);
    };

    const scheduleUpdate = () => {
      if (frame !== null) {
        return;
      }

      frame = requestAnimationFrame(update);
    };

    const measure = () => {
      resizeTimer = null;

      if (reducedMotion.matches) {
        clearMotion();
        spacer?.style.removeProperty('--mellooa-comfort-story-stage-height');
        section.classList.remove('is-scroll-driven');
        section.style.removeProperty('--mellooa-comfort-story-scroll-height');
        scroller.style.removeProperty('--mellooa-comfort-story-inset');
        scroller.scrollTop = 0;
        maxScroll = 0;
        return;
      }

      section.classList.add('is-scroll-driven');
      clearMotion();
      inset = getStableInset();
      scroller.style.setProperty('--mellooa-comfort-story-inset', `${inset.toFixed(2)}px`);

      if (desktopMotion.matches) {
        const transitionCount = Math.max(items.length - 1, 0);
        const matchingStageHeight = useCasesSection?.getBoundingClientRect().height || 0;
        const fallbackStepDistance = scroller.clientHeight * .64;
        const stageHeight = matchingStageHeight > scroller.clientHeight
          ? matchingStageHeight
          : scroller.clientHeight + fallbackStepDistance * transitionCount;

        stepDistance = transitionCount > 0
          ? (stageHeight - scroller.clientHeight) / transitionCount
          : 1;
        spacer?.style.setProperty('--mellooa-comfort-story-stage-height', `${stageHeight.toFixed(2)}px`);
      } else {
        stepDistance = 1;
        spacer?.style.removeProperty('--mellooa-comfort-story-stage-height');
      }

      maxScroll = Math.max(0, scroller.scrollHeight - scroller.clientHeight);
      section.style.setProperty('--mellooa-comfort-story-scroll-height', `${scroller.scrollHeight.toFixed(2)}px`);
      update();
    };

    const scheduleMeasure = () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(measure, 80);
    };

    window.addEventListener('scroll', scheduleUpdate, { passive: true, signal: controller.signal });
    window.addEventListener('resize', scheduleMeasure, { passive: true, signal: controller.signal });
    window.visualViewport?.addEventListener('resize', scheduleMeasure, { passive: true, signal: controller.signal });
    window.addEventListener('load', scheduleMeasure, { once: true, signal: controller.signal });
    reducedMotion.addEventListener('change', scheduleMeasure, { signal: controller.signal });
    desktopMotion.addEventListener('change', scheduleMeasure, { signal: controller.signal });

    let resizeObserver = null;

    if ('ResizeObserver' in window) {
      resizeObserver = new ResizeObserver(scheduleMeasure);

      [
        document.querySelector('.shopify-section--announcement-bar'),
        document.querySelector('.shopify-section--header'),
        useCasesSection
      ].filter(Boolean).forEach((element) => resizeObserver.observe(element));
    }

    document.addEventListener('shopify:section:unload', (event) => {
      if (event.target.contains(scroller)) {
        resizeObserver?.disconnect();
        cancelAnimationFrame(frame);
        clearTimeout(resizeTimer);
        controller.abort();
      }
    }, { signal: controller.signal });

    requestAnimationFrame(measure);
  };

  const initWithin = (scope) => {
    scope.querySelectorAll(selector).forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initWithin(document), { once: true });
  } else {
    initWithin(document);
  }

  document.addEventListener('shopify:section:load', (event) => initWithin(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mellooa-comfort-features-scroll"] && !Shopify.designMode) return;
  try {
    
(() => {
  const selector = '[data-mellooa-comfort-scroll]';

  const getStableInset = () => {
    const styles = getComputedStyle(document.documentElement);
    const value = (name) => Number.parseFloat(styles.getPropertyValue(name)) || 0;

    return value('--announcement-bar-is-sticky') * value('--announcement-bar-height')
      + value('--header-is-sticky') * value('--header-height');
  };

  const init = (scroller) => {
    if (scroller.dataset.mellooaComfortScroll === 'ready') {
      return;
    }

    const section = scroller.closest('.shopify-section--mellooa-comfort-features-scroll');

    if (!section) {
      return;
    }

    scroller.dataset.mellooaComfortScroll = 'ready';
    section.classList.add('is-scroll-driven');

    const controller = new AbortController();
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const desktopMotion = window.matchMedia('(min-width: 1000px)');
    const spacer = scroller.querySelector('.mellooa-comfort-story__spacer');
    const items = Array.from(scroller.querySelectorAll('.images-with-text-scroll__item'));
    const useCasesSection = document.querySelector('.shopify-section--mellooa-use-cases');
    let frame = null;
    let resizeTimer = null;
    let inset = 0;
    let maxScroll = 0;
    let stepDistance = 1;

    const clearMotion = () => {
      items.forEach((item) => {
        item.style.removeProperty('pointer-events');

        [
          item.querySelector('.images-with-text-scroll__image'),
          item.querySelector('.images-with-text-scroll__text')
        ].filter(Boolean).forEach((element) => {
          element.style.removeProperty('--mellooa-comfort-motion-opacity');
          element.style.removeProperty('--mellooa-comfort-motion-y');
          element.style.removeProperty('--mellooa-comfort-motion-scale');
        });
      });
    };

    const updateMotion = (progress) => {
      if (!desktopMotion.matches || reducedMotion.matches) {
        return;
      }

      const slideProgress = Math.min(items.length - 1, Math.max(0, progress / Math.max(stepDistance, 1)));
      const baseIndex = Math.min(items.length - 1, Math.floor(slideProgress));
      const localProgress = slideProgress - baseIndex;
      const smoothstep = (start, end, value) => {
        const amount = Math.min(1, Math.max(0, (value - start) / (end - start)));
        return amount * amount * (3 - 2 * amount);
      };

      items.forEach((item, index) => {
        let imageOpacity = 0;
        let textOpacity = 0;
        let imageMotionProgress = 1;
        let textMotionProgress = 1;
        let direction = 1;

        if (index === baseIndex) {
          imageMotionProgress = smoothstep(.34, .56, localProgress);
          textMotionProgress = smoothstep(.26, .44, localProgress);
          imageOpacity = 1 - imageMotionProgress;
          textOpacity = 1 - textMotionProgress;
          direction = -1;
        } else if (index === baseIndex + 1) {
          const imageEntrance = smoothstep(.44, .66, localProgress);
          const textEntrance = smoothstep(.56, .74, localProgress);
          imageOpacity = imageEntrance;
          textOpacity = textEntrance;
          imageMotionProgress = 1 - imageEntrance;
          textMotionProgress = 1 - textEntrance;
          direction = 1;
        }

        const image = item.querySelector('.images-with-text-scroll__image');
        const text = item.querySelector('.images-with-text-scroll__text');

        item.style.pointerEvents = Math.max(imageOpacity, textOpacity) > .5 ? 'auto' : 'none';

        if (image) {
          image.style.setProperty('--mellooa-comfort-motion-opacity', imageOpacity.toFixed(3));
          image.style.setProperty('--mellooa-comfort-motion-y', `${(direction * imageMotionProgress * 64).toFixed(2)}px`);
          image.style.setProperty('--mellooa-comfort-motion-scale', (1 - imageMotionProgress * .025).toFixed(3));
        }

        if (text) {
          text.style.setProperty('--mellooa-comfort-motion-opacity', textOpacity.toFixed(3));
          text.style.setProperty('--mellooa-comfort-motion-y', `${(direction * textMotionProgress * 84).toFixed(2)}px`);
          text.style.setProperty('--mellooa-comfort-motion-scale', '1');
        }
      });
    };

    const update = () => {
      frame = null;

      if (reducedMotion.matches || maxScroll <= 0) {
        return;
      }

      const sectionRect = section.getBoundingClientRect();
      const progress = Math.min(maxScroll, Math.max(0, inset - sectionRect.top));

      if (Math.abs(scroller.scrollTop - progress) > 0.5) {
        scroller.scrollTop = progress;
      }

      updateMotion(progress);
    };

    const scheduleUpdate = () => {
      if (frame !== null) {
        return;
      }

      frame = requestAnimationFrame(update);
    };

    const measure = () => {
      resizeTimer = null;

      if (reducedMotion.matches) {
        clearMotion();
        spacer?.style.removeProperty('--mellooa-comfort-story-stage-height');
        section.classList.remove('is-scroll-driven');
        section.style.removeProperty('--mellooa-comfort-story-scroll-height');
        scroller.style.removeProperty('--mellooa-comfort-story-inset');
        scroller.scrollTop = 0;
        maxScroll = 0;
        return;
      }

      section.classList.add('is-scroll-driven');
      clearMotion();
      inset = getStableInset();
      scroller.style.setProperty('--mellooa-comfort-story-inset', `${inset.toFixed(2)}px`);

      if (desktopMotion.matches) {
        const transitionCount = Math.max(items.length - 1, 0);
        const matchingStageHeight = useCasesSection?.getBoundingClientRect().height || 0;
        const fallbackStepDistance = scroller.clientHeight * .64;
        const stageHeight = matchingStageHeight > scroller.clientHeight
          ? matchingStageHeight
          : scroller.clientHeight + fallbackStepDistance * transitionCount;

        stepDistance = transitionCount > 0
          ? (stageHeight - scroller.clientHeight) / transitionCount
          : 1;
        spacer?.style.setProperty('--mellooa-comfort-story-stage-height', `${stageHeight.toFixed(2)}px`);
      } else {
        stepDistance = 1;
        spacer?.style.removeProperty('--mellooa-comfort-story-stage-height');
      }

      maxScroll = Math.max(0, scroller.scrollHeight - scroller.clientHeight);
      section.style.setProperty('--mellooa-comfort-story-scroll-height', `${scroller.scrollHeight.toFixed(2)}px`);
      update();
    };

    const scheduleMeasure = () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(measure, 80);
    };

    window.addEventListener('scroll', scheduleUpdate, { passive: true, signal: controller.signal });
    window.addEventListener('resize', scheduleMeasure, { passive: true, signal: controller.signal });
    window.visualViewport?.addEventListener('resize', scheduleMeasure, { passive: true, signal: controller.signal });
    window.addEventListener('load', scheduleMeasure, { once: true, signal: controller.signal });
    reducedMotion.addEventListener('change', scheduleMeasure, { signal: controller.signal });
    desktopMotion.addEventListener('change', scheduleMeasure, { signal: controller.signal });

    let resizeObserver = null;

    if ('ResizeObserver' in window) {
      resizeObserver = new ResizeObserver(scheduleMeasure);

      [
        document.querySelector('.shopify-section--announcement-bar'),
        document.querySelector('.shopify-section--header'),
        useCasesSection
      ].filter(Boolean).forEach((element) => resizeObserver.observe(element));
    }

    document.addEventListener('shopify:section:unload', (event) => {
      if (event.target.contains(scroller)) {
        resizeObserver?.disconnect();
        cancelAnimationFrame(frame);
        clearTimeout(resizeTimer);
        controller.abort();
      }
    }, { signal: controller.signal });

    requestAnimationFrame(measure);
  };

  const initWithin = (scope) => {
    scope.querySelectorAll(selector).forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initWithin(document), { once: true });
  } else {
    initWithin(document);
  }

  document.addEventListener('shopify:section:load', (event) => initWithin(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mellooa-help-hub"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mellooa-help-hub')) {
    customElements.define(
      'mellooa-help-hub',
      class extends HTMLElement {
        connectedCallback() {
          this.links = Array.from(this.querySelectorAll('.mellooa-help-hub__toc-item'));
          this.toc = this.querySelector('.mellooa-help-hub__toc');
          this.targets = this.links
            .map((link) => document.querySelector(link.getAttribute('href')))
            .filter(Boolean);

          this.handleLinkClick = this.handleLinkClick.bind(this);
          this.handleScroll = this.handleScroll.bind(this);
          this.updateActiveLink = this.updateActiveLink.bind(this);
          this.links.forEach((link) => link.addEventListener('click', this.handleLinkClick));

          window.addEventListener('scroll', this.handleScroll, { passive: true });
          window.addEventListener('resize', this.updateActiveLink);
          window.addEventListener('hashchange', this.updateActiveLink);
          this.updateActiveLink();
        }

        disconnectedCallback() {
          this.links.forEach((link) => link.removeEventListener('click', this.handleLinkClick));
          window.removeEventListener('scroll', this.handleScroll);
          window.removeEventListener('resize', this.updateActiveLink);
          window.removeEventListener('hashchange', this.updateActiveLink);
          window.clearTimeout(this.scrollEndTimer);
        }

        handleLinkClick(event) {
          const link = event.currentTarget;
          const id = link.getAttribute('href').slice(1);
          const target = document.getElementById(id);

          if (!target) return;

          event.preventDefault();
          this.isProgrammaticScrolling = true;
          this.setActiveLink(id);
          window.clearTimeout(this.scrollEndTimer);
          this.scrollEndTimer = window.setTimeout(() => {
            this.isProgrammaticScrolling = false;
            this.updateActiveLink();
          }, 600);

          window.history.replaceState(null, '', `#${id}`);

          target.scrollIntoView({
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
            block: 'start'
          });
        }

        handleScroll() {
          if (!this.isProgrammaticScrolling) {
            this.updateActiveLink();
            return;
          }

          window.clearTimeout(this.scrollEndTimer);
          this.scrollEndTimer = window.setTimeout(() => {
            this.isProgrammaticScrolling = false;
            this.updateActiveLink();
          }, 140);
        }

        updateActiveLink() {
          if (this.targets.length === 0) return;

          const threshold = window.innerHeight * 0.22;
          let activeTarget = this.targets[0];

          for (const target of this.targets) {
            if (target.getBoundingClientRect().top <= threshold) {
              activeTarget = target;
            } else {
              break;
            }
          }

          this.setActiveLink(activeTarget.id);
        }

        setActiveLink(id) {
          if (this.activeId === id) return;

          this.activeId = id;
          let activeLink;

          this.links.forEach((link) => {
            const isActive = link.getAttribute('href') === `#${id}`;
            link.classList.toggle('is-active', isActive);

            if (isActive) {
              activeLink = link;
              link.setAttribute('aria-current', 'location');
            } else {
              link.removeAttribute('aria-current');
            }
          });

          if (activeLink && this.toc && window.matchMedia('(max-width: 999px)').matches) {
            const targetLeft = activeLink.offsetLeft - (this.toc.clientWidth - activeLink.clientWidth) / 2;
            this.toc.scrollTo({
              left: Math.max(0, targetLeft),
              behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
            });
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mellooa-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mellooa-reviews')) {
    customElements.define(
      'mellooa-reviews',
      class extends HTMLElement {
        connectedCallback() {
          this.items = Array.from(this.querySelectorAll('[data-review-item]'));
          this.list = this.querySelector('[data-review-list]');
          this.filters = Array.from(this.querySelectorAll('[data-review-filter]'));
          this.photoFilter = this.querySelector('[data-review-filter="photos"]');
          this.sort = this.querySelector('[data-review-sort]');
          this.loadMore = this.querySelector('[data-review-load-more]');
          this.visibleCount = this.querySelector('[data-review-visible]');
          this.totalCount = this.querySelector('[data-review-total]');
          this.empty = this.querySelector('[data-review-empty]');
          this.initialCount = Number(this.dataset.initialCount) || 4;
          this.loadCount = Number(this.dataset.loadCount) || 4;
          this.totalReviewCount = Number(this.dataset.totalCount) || this.items.length;
          this.sectionId = this.dataset.sectionId;
          this.nextPageUrl = this.querySelector('[data-review-next-url]')?.dataset.reviewNextUrl || '';
          this.loadingPages = false;
          this.limit = this.initialCount;
          this.activeFilter = 'all';

          this.filters.forEach((button) => {
            button.addEventListener('click', () => {
              this.activeFilter = button.dataset.reviewFilter;
              this.limit = this.initialCount;
              this.filters.forEach((filter) => filter.setAttribute('aria-pressed', String(filter === button)));
              this.render();
            });
          });

          this.sort?.addEventListener('change', () => {
            this.limit = this.initialCount;
            this.render();
          });

          this.loadMore?.addEventListener('click', async () => {
            this.limit += this.loadCount;
            if (this.limit > this.items.length && this.nextPageUrl) {
              await this.loadRemainingPages();
            }
            this.render();
          });

          this.render();
          this.loadRemainingPages();
        }

        async loadRemainingPages() {
          if (this.loadingPages || !this.nextPageUrl || !this.sectionId) {
            return;
          }

          this.loadingPages = true;

          try {
            while (this.nextPageUrl) {
              const pageUrl = new URL(this.nextPageUrl, window.location.origin);
              pageUrl.searchParams.set('section_id', this.sectionId);

              const response = await fetch(pageUrl.toString(), {
                headers: { 'X-Requested-With': 'XMLHttpRequest' },
              });

              if (!response.ok) {
                throw new Error(`Review page request failed: ${response.status}`);
              }

              const html = await response.text();
              const page = new DOMParser().parseFromString(html, 'text/html');
              const nextReviews = Array.from(page.querySelectorAll('[data-review-item]'));
              const nextMarker = page.querySelector('[data-review-next-url]');

              nextReviews.forEach((item) => this.list?.append(item));
              this.items.push(...nextReviews);
              this.nextPageUrl = nextMarker?.dataset.reviewNextUrl || '';
            }
          } catch (error) {
            this.dataset.paginationState = 'retry';
          } finally {
            this.loadingPages = false;
            this.render();
          }
        }

        render() {
          const hasPhotos = this.items.some((item) => item.dataset.reviewHasPhoto === 'true');

          if (this.photoFilter) {
            this.photoFilter.hidden = !hasPhotos;
          }

          if (!hasPhotos && this.activeFilter === 'photos') {
            this.activeFilter = 'all';
            this.filters.forEach((filter) => filter.setAttribute('aria-pressed', String(filter.dataset.reviewFilter === 'all')));
          }

          const matching = this.items.filter((item) => {
            if (this.activeFilter === 'photos') {
              return item.dataset.reviewHasPhoto === 'true';
            }

            return true;
          });

          const byRecent = (a, b) => Date.parse(b.dataset.reviewDate) - Date.parse(a.dataset.reviewDate);

          matching.sort((a, b) => {
            if (this.sort?.value === 'high') {
              return Number(b.dataset.reviewRating) - Number(a.dataset.reviewRating);
            }

            if (this.sort?.value === 'low') {
              return Number(a.dataset.reviewRating) - Number(b.dataset.reviewRating);
            }

            return byRecent(a, b);
          });

          if (this.sort?.value === 'relevant') {
            const negativeIndex = matching.findIndex((item, index) => index >= 2 && Number(item.dataset.reviewRating) <= 2);

            if (negativeIndex > 2) {
              const [negativeReview] = matching.splice(negativeIndex, 1);
              matching.splice(2, 0, negativeReview);
            }
          }

          matching.forEach((item) => this.list?.append(item));
          this.items.forEach((item) => {
            item.hidden = true;
          });
          matching.slice(0, this.limit).forEach((item) => {
            item.hidden = false;
          });

          const visible = Math.min(this.limit, matching.length);
          const total = this.activeFilter === 'all' ? Math.max(matching.length, this.totalReviewCount) : matching.length;
          this.visibleCount.textContent = String(visible);
          this.totalCount.textContent = String(total);
          this.empty.hidden = total !== 0;
          this.loadMore.hidden = visible >= total;
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mellooa-shop-shelf"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mellooa-shop-shelf')) {
    customElements.define('mellooa-shop-shelf', class extends HTMLElement {
      connectedCallback() {
        this.abortController = new AbortController();
        this.preloadedImages = new Map();
        const warmImages = () => {
          this.querySelectorAll('[data-variant-option][data-image-available="true"]').forEach((option) => this.preloadOption(option));
        };
        if ('requestIdleCallback' in window) {
          this.imageWarmHandle = window.requestIdleCallback(warmImages, { timeout: 1500 });
        } else {
          this.imageWarmHandle = window.setTimeout(warmImages, 900);
        }
        this.addEventListener('pointerover', (event) => {
          const option = event.target.closest('[data-variant-option]');
          if (option) this.preloadOption(option);
        }, { signal: this.abortController.signal });
        this.addEventListener('focusin', (event) => {
          const option = event.target.closest('[data-variant-option]');
          if (option) this.preloadOption(option);
        }, { signal: this.abortController.signal });

        this.addEventListener('change', async (event) => {
          const option = event.target.closest('[data-variant-option]');
          if (!option || !this.contains(option)) return;

          const card = option.closest('.mellooa-shop-card');
          let image = card?.querySelector('[data-card-image]');
          const placeholder = card?.querySelector('[data-card-image-placeholder]');
          const link = card?.querySelector('[data-card-link]');
          const selectedOption = card?.querySelector('[data-selected-option]');

          if (link && option.dataset.variantUrl) link.href = option.dataset.variantUrl;
          if (selectedOption) selectedOption.textContent = option.dataset.optionLabel || '';

          const imageIsAvailable = option.dataset.imageAvailable === 'true' && option.dataset.imageSrc;
          const switchToken = option.value || option.id || option.dataset.imageSrc || '';
          if (card) card.dataset.imageSwitchToken = switchToken;
          if (!imageIsAvailable) {
            if (image) image.hidden = true;
            if (placeholder) placeholder.hidden = false;
            return;
          }

          if (!image) {
            image = document.createElement('img');
            image.className = 'mellooa-shop-card__image';
            image.setAttribute('data-card-image', '');
            image.decoding = 'async';
            card?.querySelector('.mellooa-shop-card__media')?.prepend(image);
          }

          const preloadSucceeded = await this.preloadOption(option);
          if (!this.isConnected || card?.dataset.imageSwitchToken !== switchToken) return;
          if (!preloadSucceeded) {
            image.hidden = true;
            if (placeholder) placeholder.hidden = false;
            return;
          }

          if (placeholder) placeholder.hidden = true;
          image.alt = option.dataset.imageAlt || '';
          image.srcset = option.dataset.imageSrcset || '';
          image.src = option.dataset.imageSrc;
          image.hidden = false;
        }, { signal: this.abortController.signal });
      }

      preloadOption(option) {
        if (option.dataset.imageAvailable !== 'true' || !option.dataset.imageSrc) return Promise.resolve(false);
        const key = `${option.dataset.imageSrc}|${option.dataset.imageSrcset || ''}`;
        if (this.preloadedImages.has(key)) return this.preloadedImages.get(key);

        const promise = new Promise((resolve) => {
          const preload = new Image();
          preload.decoding = 'async';
          preload.onload = () => resolve(true);
          preload.onerror = () => resolve(false);
          preload.srcset = option.dataset.imageSrcset || '';
          preload.sizes = '(max-width: 699px) calc(100vw - 40px), (max-width: 999px) 50vw, 33vw';
          preload.src = option.dataset.imageSrc;
        });
        this.preloadedImages.set(key, promise);
        return promise;
      }

      disconnectedCallback() {
        this.abortController?.abort();
        if ('cancelIdleCallback' in window) window.cancelIdleCallback(this.imageWarmHandle);
        else window.clearTimeout(this.imageWarmHandle);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mellooa-use-cases-scroll"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mellooa-use-cases-scroll')) {
  customElements.define('mellooa-use-cases-scroll', class MellooaUseCasesScroll extends HTMLElement {
    connectedCallback() {
      if (!this.initialized) {
        this.initialized = true;
        this.connected = false;
        this.sticky = this.querySelector('.mellooa-use-cases__sticky');
        this.viewport = this.querySelector('.mellooa-use-cases__viewport');
        this.track = this.querySelector('.mellooa-use-cases__track');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.snapEnabled = this.dataset.snap === 'true';
        this.travelFactor = Number.parseFloat(this.dataset.travelFactor) || .8;
        this.frame = null;
        this.initialFrame = null;
        this.resizeTimer = null;
        this.snapTimer = null;
        this.snapReleaseTimer = null;
        this.wheelTimer = null;
        this.snapping = false;
        this.wheelActive = false;
        this.pointerId = null;
        this.dragAxis = null;
        this.dragging = false;
        this.directInputSectionStart = null;
        this.pointerVelocityX = 0;
        this.sceneImages = Array.from(this.querySelectorAll('.mellooa-use-cases__image'));
        this.imageOffsets = [];
        this.imageWarmDistance = 0;
        this.warmedImages = new WeakSet();
        this.onScroll = this.onScroll.bind(this);
        this.onResize = this.onResize.bind(this);
        this.onPointerDown = this.onPointerDown.bind(this);
        this.onPointerMove = this.onPointerMove.bind(this);
        this.onPointerEnd = this.onPointerEnd.bind(this);
        this.onWheel = this.onWheel.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.onDragStart = this.onDragStart.bind(this);

        this.sceneImages.slice(0, 2).forEach((image, index) => {
          this.warmImage(image, index === 0 ? 'high' : 'auto');
        });
      }

      if (this.connected || this.reducedMotion.matches) return;

      this.connected = true;
      this.snapping = false;

      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize, { passive: true });
      window.addEventListener('pointerup', this.onPointerEnd, { passive: true });
      window.addEventListener('pointercancel', this.onPointerEnd, { passive: true });
      this.viewport.addEventListener('pointerdown', this.onPointerDown, { passive: true });
      this.viewport.addEventListener('pointermove', this.onPointerMove, { passive: false });
      this.viewport.addEventListener('wheel', this.onWheel, { passive: false });
      this.viewport.addEventListener('keydown', this.onKeyDown);
      this.viewport.addEventListener('dragstart', this.onDragStart);

      if ('ResizeObserver' in window) {
        this.resizeObserver ||= new ResizeObserver(this.onResize);
        [
          this.sticky,
          document.querySelector('.shopify-section--announcement-bar'),
          document.querySelector('.shopify-section--header')
        ].filter(Boolean).forEach((element) => this.resizeObserver.observe(element));
      }

      this.initialFrame = requestAnimationFrame(() => {
        this.initialFrame = null;

        if (!this.isConnected) return;

        this.measure();
        this.update();
      });
    }

    disconnectedCallback() {
      if (!this.initialized || !this.connected) return;

      this.connected = false;
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
      window.removeEventListener('pointerup', this.onPointerEnd);
      window.removeEventListener('pointercancel', this.onPointerEnd);
      this.viewport.removeEventListener('pointerdown', this.onPointerDown);
      this.viewport.removeEventListener('pointermove', this.onPointerMove);
      this.viewport.removeEventListener('wheel', this.onWheel);
      this.viewport.removeEventListener('keydown', this.onKeyDown);
      this.viewport.removeEventListener('dragstart', this.onDragStart);
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.frame);
      cancelAnimationFrame(this.initialFrame);
      clearTimeout(this.resizeTimer);
      clearTimeout(this.snapTimer);
      clearTimeout(this.snapReleaseTimer);
      clearTimeout(this.wheelTimer);
      this.frame = null;
      this.initialFrame = null;
      this.snapping = false;
      this.wheelActive = false;
      this.pointerId = null;
      this.dragAxis = null;
      this.dragging = false;
      this.directInputSectionStart = null;
      this.classList.remove('is-dragging');
    }

    measure() {
      const cells = Array.from(this.track.querySelectorAll('.mellooa-use-cases__cell'));
      const visibleCells = cells.filter((cell) => getComputedStyle(cell).display !== 'none');
      const firstCell = visibleCells[0];

      if (!firstCell) return;

      const cellWidth = firstCell.getBoundingClientRect().width;
      const mobile = window.matchMedia('(max-width: 699px)').matches;
      const tailCellCount = visibleCells.filter((cell) => cell.classList.contains('mellooa-use-cases__cell--tail')).length;
      const activeCellCount = Math.max(visibleCells.length - tailCellCount, 1);
      const additionalCells = Math.max(activeCellCount - 8, 0);
      const firstLabelText = this.track.querySelector('[data-mellooa-label-text]');
      const finalSceneImage = this.track.querySelector('.mellooa-use-cases__cell--final-scene .mellooa-use-cases__image');

      this.imageOffsets = this.sceneImages.map((image) => (
        image.closest('.mellooa-use-cases__cell')?.offsetLeft ?? Number.POSITIVE_INFINITY
      ));
      this.imageWarmDistance = cellWidth * 2;

      this.stepCount = Math.max(activeCellCount - (mobile ? 2 : 1), 1);

      if (mobile) {
        const firstLabelWidth = firstLabelText?.getBoundingClientRect().width || 0;
        const finalImageWidth = finalSceneImage?.getBoundingClientRect().width || 0;
        const endAlignmentShift = Math.max((finalImageWidth - firstLabelWidth) / 2, 0);
        const rootStyles = getComputedStyle(document.documentElement);
        const value = (name) => Number.parseFloat(rootStyles.getPropertyValue(name)) || 0;
        const stickyInset = value('--announcement-bar-is-sticky') * value('--announcement-bar-height')
          + value('--header-is-sticky') * value('--header-height');

        this.style.setProperty('--mellooa-use-cases-end-alignment-shift', `${endAlignmentShift}px`);
        this.style.setProperty('--mellooa-use-cases-sticky-inset', `${stickyInset}px`);
        this.distance = cellWidth * this.stepCount;
        this.duration = window.innerWidth + additionalCells * cellWidth * .65;
      } else {
        const trackTransform = getComputedStyle(this.track).transform;
        const currentTranslateX = trackTransform === 'none' ? 0 : new DOMMatrixReadOnly(trackTransform).m41;
        const finalEdge = (finalSceneImage?.getBoundingClientRect().right || window.innerWidth) - currentTranslateX;
        const containerGutterValue = getComputedStyle(this).getPropertyValue('--container-gutter').trim();
        const rootFontSize = Number.parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;
        const containerGutter = containerGutterValue.endsWith('rem')
          ? Number.parseFloat(containerGutterValue) * rootFontSize
          : Number.parseFloat(containerGutterValue) || 48;
        const baseDuration = window.innerWidth + additionalCells * cellWidth * .65;

        this.style.removeProperty('--mellooa-use-cases-end-alignment-shift');
        this.style.removeProperty('--mellooa-use-cases-sticky-inset');
        this.distance = Math.max(finalEdge - (window.innerWidth - containerGutter), 0);
        this.duration = baseDuration;
      }

      this.style.setProperty('--mellooa-use-cases-scroll-height', `${this.sticky.offsetHeight + this.duration}px`);
      this.warmImagesForProgress(this.progress || 0);
    }

    onResize() {
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => {
        this.measure();
        this.update();
      }, 80);
    }

    isThemeEditor() {
      return Boolean(window.Shopify?.designMode);
    }

    onScroll() {
      if (this.frame === null) {
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.update();
        });
      }

      if (!this.isThemeEditor()) return;

      this.stopSnap();
      clearTimeout(this.wheelTimer);
      this.wheelActive = false;
      this.directInputSectionStart = null;
    }

    update() {
      if (!this.duration) return;

      const sectionTop = this.getBoundingClientRect().top;
      const progress = Math.min(Math.max(-sectionTop / this.duration, 0), 1);
      this.progress = progress;
      this.track.style.transform = `translate3d(${-this.distance * progress}px, 0, 0)`;
      this.warmImagesForProgress(progress);
    }

    scrollToProgress(progress) {
      if (!this.duration) return;

      const boundedProgress = Math.min(Math.max(progress, 0), 1);
      const sectionStart = this.directInputSectionStart
        ?? this.getBoundingClientRect().top + window.scrollY;

      this.progress = boundedProgress;
      this.track.style.transform = `translate3d(${-this.distance * boundedProgress}px, 0, 0)`;
      this.warmImagesForProgress(boundedProgress);
      window.scrollTo({ top: sectionStart + boundedProgress * this.duration, behavior: 'auto' });
    }

    warmImagesForProgress(progress) {
      if (!this.sceneImages.length || !this.imageOffsets.length) return;

      const preloadEdge = this.distance * progress + this.viewport.clientWidth + this.imageWarmDistance;

      this.sceneImages.forEach((image, index) => {
        if (this.imageOffsets[index] <= preloadEdge) this.warmImage(image);
      });
    }

    warmImage(image, priority = 'low') {
      if (!image || this.warmedImages.has(image)) return;

      this.warmedImages.add(image);
      image.loading = 'eager';
      if (image.fetchPriority !== 'high') image.fetchPriority = priority;
      image.dataset.mellooaPreload = 'requested';

      const markDecoded = () => {
        if (image.naturalWidth > 0) image.dataset.mellooaPreload = 'decoded';
      };
      const waitForLoad = () => {
        if (image.complete) {
          markDecoded();
        } else {
          image.addEventListener('load', markDecoded, { once: true });
        }
      };

      if (typeof image.decode === 'function') {
        image.decode().then(markDecoded).catch(waitForLoad);
      } else {
        waitForLoad();
      }
    }

    stopSnap() {
      const wasSnapping = this.snapping;

      clearTimeout(this.snapTimer);
      clearTimeout(this.snapReleaseTimer);
      this.snapping = false;

      if (wasSnapping) window.scrollTo({ top: window.scrollY, behavior: 'auto' });
    }

    onPointerDown(event) {
      if (this.isThemeEditor()) return;
      if (!this.duration || this.pointerId !== null) return;
      if (event.pointerType === 'mouse' && event.button !== 0) return;

      this.stopSnap();
      clearTimeout(this.wheelTimer);
      this.wheelActive = false;
      this.directInputSectionStart = this.getBoundingClientRect().top + window.scrollY;
      this.pointerId = event.pointerId;
      this.dragAxis = null;
      this.dragging = false;
      this.dragStartX = event.clientX;
      this.dragStartY = event.clientY;
      this.dragStartProgress = this.progress || 0;
      this.lastPointerX = event.clientX;
      this.lastPointerTime = performance.now();
      this.pointerVelocityX = 0;
    }

    onPointerMove(event) {
      if (this.isThemeEditor()) return;
      if (event.pointerId !== this.pointerId || !this.duration || !this.distance) return;

      const deltaX = event.clientX - this.dragStartX;
      const deltaY = event.clientY - this.dragStartY;

      if (!this.dragAxis) {
        if (Math.max(Math.abs(deltaX), Math.abs(deltaY)) < 8) return;

        this.dragAxis = Math.abs(deltaX) > Math.abs(deltaY) * 1.1 ? 'x' : 'y';

        if (this.dragAxis !== 'x') return;

        this.dragging = true;
        this.classList.add('is-dragging');

        try {
          this.viewport.setPointerCapture(event.pointerId);
        } catch (error) {
          this.dragging = true;
        }
      }

      if (this.dragAxis !== 'x') return;

      event.preventDefault();

      const now = performance.now();
      const elapsed = Math.max(now - this.lastPointerTime, 1);
      const velocity = (event.clientX - this.lastPointerX) / elapsed;

      this.pointerVelocityX = this.pointerVelocityX * .65 + velocity * .35;
      this.lastPointerX = event.clientX;
      this.lastPointerTime = now;
      this.scrollToProgress(this.dragStartProgress - deltaX / this.distance);
    }

    onPointerEnd(event) {
      if (event.pointerId !== this.pointerId) return;

      const wasHorizontal = this.dragAxis === 'x';
      const velocityIsFresh = performance.now() - this.lastPointerTime < 120;
      const flickDirection = velocityIsFresh && Math.abs(this.pointerVelocityX) > .35
        ? (this.pointerVelocityX < 0 ? 1 : -1)
        : 0;

      if (this.viewport.hasPointerCapture?.(event.pointerId)) {
        this.viewport.releasePointerCapture(event.pointerId);
      }

      this.pointerId = null;
      this.dragAxis = null;
      this.dragging = false;
      this.directInputSectionStart = null;
      this.pointerVelocityX = 0;
      this.classList.remove('is-dragging');

      if (wasHorizontal && this.snapEnabled && !this.isThemeEditor()) {
        clearTimeout(this.snapTimer);
        this.snapTimer = setTimeout(() => this.snap(event.type === 'pointercancel' ? 0 : flickDirection), 40);
      }
    }

    onWheel(event) {
      if (this.isThemeEditor()) return;
      if (!this.duration || !this.distance || this.pointerId !== null) return;
      if (Math.abs(event.deltaX) <= Math.max(4, Math.abs(event.deltaY) * 1.1)) {
        this.stopSnap();
        clearTimeout(this.wheelTimer);
        this.wheelActive = false;
        this.directInputSectionStart = null;
        return;
      }

      event.preventDefault();

      if (!this.wheelActive) {
        this.stopSnap();
        this.directInputSectionStart = this.getBoundingClientRect().top + window.scrollY;
      }

      this.wheelActive = true;

      const deltaUnit = event.deltaMode === 1
        ? 16
        : (event.deltaMode === 2 ? this.viewport.clientWidth : 1);

      this.scrollToProgress((this.progress || 0) + event.deltaX * deltaUnit / this.distance);
      clearTimeout(this.wheelTimer);
      this.wheelTimer = setTimeout(() => {
        this.wheelActive = false;
        this.directInputSectionStart = null;
        if (this.snapEnabled && !this.isThemeEditor()) this.snap();
      }, 180);
    }

    onKeyDown(event) {
      if (this.isThemeEditor()) return;
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') {
        if (['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', ' '].includes(event.key)) this.stopSnap();
        return;
      }

      event.preventDefault();
      this.stopSnap();
      this.snap(event.key === 'ArrowRight' ? 1 : -1);
    }

    onDragStart(event) {
      event.preventDefault();
    }

    snap(direction = 0) {
      if (this.isThemeEditor()) {
        clearTimeout(this.snapTimer);
        clearTimeout(this.snapReleaseTimer);
        this.snapping = false;
        return;
      }

      if (!this.duration || this.progress == null) return;

      const currentStep = this.progress * this.stepCount;
      let snappedStep = Math.round(currentStep);

      if (direction > 0) snappedStep = Math.floor(currentStep + .01) + 1;
      if (direction < 0) snappedStep = Math.ceil(currentStep - .01) - 1;

      snappedStep = Math.min(Math.max(snappedStep, 0), this.stepCount);

      const snappedProgress = snappedStep / this.stepCount;
      const sectionStart = this.getBoundingClientRect().top + window.scrollY;
      const target = sectionStart + snappedProgress * this.duration;

      if (Math.abs(target - window.scrollY) < 2) return;

      this.snapping = true;
      window.scrollTo({ top: target, behavior: 'smooth' });
      clearTimeout(this.snapReleaseTimer);
      this.snapReleaseTimer = setTimeout(() => {
        this.snapping = false;
      }, 520);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"]) return;
  try {
    
  if (!customElements.get('newsletter-popup-launcher')) {
    class NewsletterPopupLauncher extends HTMLElement {
      connectedCallback() {
        this.popup = document.getElementById(this.getAttribute('popup-id'));
        this.button = this.querySelector('button');

        if (!this.popup || !this.button) {
          this.hidden = true;
          return;
        }

        this.abortController = new AbortController();
        const listenerOptions = { signal: this.abortController.signal };

        this.button.addEventListener('click', () => {
          this.openedFromLauncher = true;
        }, listenerOptions);

        this.popup.addEventListener('dialog:before-show', () => {
          this.hideLauncher();
        }, listenerOptions);

        this.popup.addEventListener('dialog:after-show', () => {
          if (!this.openedFromLauncher) {
            return;
          }

          this.popup.querySelector('input[type="email"]')?.focus({ preventScroll: true });
          this.openedFromLauncher = false;
        }, listenerOptions);

        this.popup.addEventListener('dialog:before-hide', () => {
          this.shouldRestoreFocus = this.popup.contains(document.activeElement);
        }, listenerOptions);

        this.popup.addEventListener('dialog:after-hide', () => {
          const launcherWasShown = this.showLauncher();

          if (launcherWasShown && this.shouldRestoreFocus) {
            this.button.focus({ preventScroll: true });
          }

          this.shouldRestoreFocus = false;
        }, listenerOptions);

        requestAnimationFrame(() => this.syncInitialState());
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }

      syncInitialState() {
        const popupHasAlreadyAppeared = this.readLocalStorage('theme:popup-appeared') === 'true';
        const shouldOfferReopen = this.popup.hasAttribute('only-once') && popupHasAlreadyAppeared;

        if (!this.popup.hasAttribute('open') && shouldOfferReopen) {
          this.showLauncher();
        }
      }

      showLauncher() {
        if (this.readLocalStorage('theme:popup-filled') === 'true') {
          this.hideLauncher();
          return false;
        }

        this.hidden = false;
        this.button.classList.remove('is-reminding');

        if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          requestAnimationFrame(() => this.button.classList.add('is-reminding'));
          this.button.addEventListener('animationend', () => {
            this.button.classList.remove('is-reminding');
          }, { once: true, signal: this.abortController.signal });
        }

        return true;
      }

      hideLauncher() {
        this.hidden = true;
        this.button?.classList.remove('is-reminding');
      }

      readLocalStorage(key) {
        try {
          return localStorage.getItem(key);
        } catch (error) {
          return null;
        }
      }
    }

    customElements.define('newsletter-popup-launcher', NewsletterPopupLauncher);
  }

  } catch(e) { console.error(e); }
})();
})();
